import OverviewEventHandlerBase from "./OverviewEventHandlerBase";

class OverviewEventHandlerDelete extends OverviewEventHandlerBase {
    public onAction(pointerToComponentOrUtil, id) {
        pointerToComponentOrUtil.deleteConfirm.renderMessageBoxOnly(pointerToComponentOrUtil, id);
    }
}

export default OverviewEventHandlerDelete;